<div (contextmenu)="$event.preventDefault()" id="loading">
  <div class="loader-container">
    <div class="loader"></div>
  </div>
</div>
